<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import SettingsHeader from './SettingsHeader.vue';
const props = defineProps({
  headerTitle: { type: String, default: '' },
  titleIcon: { type: String, default: '' },
  keepAlive: { type: Boolean, default: true },
  showBackButton: { type: Boolean, default: false },
  backUrl: { type: [String, Object], default: '' },
});

const { t } = useI18n();

const showSettingsHeader = computed(
  () => props.headerTitle || props.titleIcon || props.showBackButton
);

const translatedHeaderTitle = computed(() => {
  if (!props.headerTitle) return '';
  /* Route passes known i18n keys from settings route props. */
  // eslint-disable-next-line @intlify/vue-i18n/no-dynamic-keys
  return t(props.headerTitle);
});
</script>

<template>
  <div class="flex flex-col h-full m-0 bg-n-surface-1 w-full">
    <SettingsHeader
      v-if="showSettingsHeader"
      :header-title="translatedHeaderTitle"
      :title-icon="titleIcon"
      :show-back-button="showBackButton"
      :back-url="backUrl"
      class="z-20 mx-auto w-full max-w-7xl"
    />

    <router-view
      v-slot="{ Component }"
      class="flex min-h-0 flex-1 flex-col overflow-hidden px-0"
    >
      <component :is="Component" v-if="!keepAlive" :key="$route.fullPath" />
      <keep-alive v-else>
        <component :is="Component" :key="$route.fullPath" />
      </keep-alive>
    </router-view>
  </div>
</template>
